<template>
  <div class="tabs">
    <b-tabs v-model="activeTab" @change="handleTabChange">
      <b-tab title="Tour List" @click="changeTab(0)">
        <router-view />
      </b-tab>
      <b-tab title="Item List" @click="changeTab(1)">
        <router-view />
      </b-tab>
      <b-tab title="Audit-Logs" @click="changeTab(2)">
        <router-view />
      </b-tab>
      <b-tab title="Cities" @click="changeTab(3)">
        <router-view />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const activeTab = ref(getInitialTabIndex());

    function getInitialTabIndex() {
      const tab = route.path.split('/').pop();
      switch (tab) {
        case 'tourlistriver':
          return 0;
        case 'itemlistriver':
          return 1;
        case 'auditriver':
          return 2;
        case 'city':
          return 3;
        default:
          return 0; // fallback to first tab if no match
      }
    }

    function handleTabChange(tabIndex) {
      const tabMap = ['tourlistriver', 'itemlistriver', 'auditriver', 'city'];
      const tabName = tabMap[tabIndex] || 'tourlistriver'; // fallback to index 0
      router.push(`/calculation-river/${tabName}`);
    }

    function changeTab(tabIndex) {
      handleTabChange(tabIndex);
    }

    watch(route, () => {
      activeTab.value = getInitialTabIndex();
    });

    // Initialize tab index on mount
    onMounted(() => {
      activeTab.value = getInitialTabIndex();
    });

    return {
      activeTab,
      handleTabChange,
      changeTab
    };
  }
};
</script>

<style scoped>
.tabs {
  position: fixed;
  top: 10;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  padding: 10px;
}

body {
  overflow: hidden;
  /* Disable scrolling for the entire page */
  margin: 0;
  padding: 0;
}
</style>
